import { ref, watch } from "vue";
import { u as unwrapEl } from "../utils/unwrapEl-55936fea.mjs";
import { u as useRequestAnimationFrame } from "./useRequestAnimationFrame-8c0a599c.mjs";
const keys = ["x", "y", "width", "height", "top", "left", "right", "bottom"];
const isDomRectEqual = (a, b) => {
  for (let i = 0; i < keys.length; i++) {
    if (a[keys[i]] !== b[keys[i]]) {
      return false;
    }
  }
  return true;
};
const useDomRect = (target) => {
  const domRect = ref(null);
  let prev = {};
  useRequestAnimationFrame(() => {
    const el = unwrapEl(target.value);
    if (!el) {
      return;
    }
    const rect = el.getBoundingClientRect();
    if (!isDomRectEqual(rect, prev)) {
      domRect.value = rect;
    }
    prev = rect;
  });
  watch(target, (newVal) => {
    const el = unwrapEl(newVal);
    if (el) {
      domRect.value = el.getBoundingClientRect();
    } else {
      domRect.value = null;
    }
  });
  return {
    domRect
  };
};
export {
  useDomRect as u
};
//# sourceMappingURL=useDomRect-32e0f717.mjs.map
